import React from 'react';
import imgVector from '../../assets/sections/a114ac1575e0303158ba016f7b07b5da56979d66.svg';
import imgVector1 from '../../assets/sections/8e85af30cecd69a3f52727d6eb0b9a9496a8be89.svg';
import imgAnhNgang1 from '../../assets/sections/14fe042f49201898d15c93fedc34abc6e9e6ae3e.png';
import imgTopcvLogoOnDarkBlue1 from '../../assets/sections/841adb0c872226490c5e44a0aa3bc15f7d074ad7.png';
import imgIcon1 from '../../assets/sections/bce3fe41c2c68696f51e612938198f08b51a0a10.png';
import imgTopcvBrandTheArrowWhite3 from '../../assets/sections/cf015bcfbc57536bae83cb9e7dc12be2e55f0c09.png';
import imgGroup8 from '../../assets/sections/0abbaa1a6573b86a6e8271fd44383cf732ebb8c6.svg';

function BoldMapLocationMapPoint({ className }) {
  return (
    <div className={className || "overflow-clip relative size-[32px]"}>
      <div className="absolute inset-[8.33%_16.67%]">
        <img alt="" className="absolute block max-w-none size-full" src={imgVector} />
      </div>
    </div>
  );
}

function BoldTimeAlarm({ className }) {
  return (
    <div className={className || "overflow-clip relative size-[32px]"}>
      <div className="absolute inset-[8.33%_12.5%]">
        <img alt="" className="absolute block max-w-none size-full" src={imgVector1} />
      </div>
    </div>
  );
}

export default function Hero() {
  return (
    <div className="relative w-[1921px] h-[1080px]">
      <div className="absolute h-[1080px] left-0 top-0 w-[1921px]">
        <img alt="" className="absolute inset-0 max-w-none object-cover pointer-events-none size-full" src={imgAnhNgang1} />
      </div>
      <div className="absolute h-[117px] left-[541px] top-[429px] w-[512px]">
        <img alt="" className="absolute block max-w-none size-full" src={imgGroup8} />
      </div>
      <div className="absolute content-stretch flex flex-col gap-[24px] items-start leading-[normal] left-[134px] top-[335px] uppercase w-[863px]">
        <p className="font-['Alexandria',sans-serif] font-medium relative shrink-0 text-[64px] text-white w-full">
          Tiếp lợi thế
        </p>
        <p className="bg-clip-text font-['Alexandria',sans-serif] font-bold relative shrink-0 text-[70px] text-[transparent] w-full" style={{ backgroundImage: "linear-gradient(7.65083deg, rgb(255, 255, 255) 62.865%, rgb(165, 245, 255) 136.86%)" }}>
          Sự nghiệp Hải Phòng
        </p>
      </div>
      <div className="absolute content-stretch flex flex-col gap-[16px] items-start left-[134px] top-[574px] w-[561px]">
        <div className="content-stretch flex gap-[16px] items-center relative shrink-0 w-full">
          <BoldTimeAlarm className="overflow-clip relative shrink-0 size-[32px]" />
          <p className="font-['Alexandria',sans-serif] font-normal leading-[normal] relative shrink-0 text-[32px] text-white whitespace-nowrap">
            Thời gian: 20.03.2026 - 15.04.2026
          </p>
        </div>
        <div className="content-stretch flex gap-[16px] items-center relative shrink-0 w-full">
          <BoldMapLocationMapPoint className="overflow-clip relative shrink-0 size-[32px]" />
          <p className="font-['Alexandria',sans-serif] font-normal leading-[normal] relative shrink-0 text-[32px] text-white whitespace-nowrap">
            Địa điểm: Hải Phòng
          </p>
        </div>
      </div>
      <a
        href="#timeline"
        onClick={(e) => {
          e.preventDefault();
          const timeline = document.getElementById('timeline');
          if (timeline) {
            const top = timeline.getBoundingClientRect().top + window.scrollY;
            window.scrollTo({ top, behavior: 'smooth' });
          }
        }}
        className="cursor-pointer absolute bg-[#ff3535] content-stretch flex h-[80px] items-center justify-center left-[134px] px-[19px] py-[14px] rounded-[16px] shadow-[0px_24px_84px_0px_rgba(0,0,0,0.1)] top-[751px] w-[245px]"
      >
        <p className="font-['Alexandria',sans-serif] font-bold leading-[1.5] relative shrink-0 text-[21px] text-center text-white whitespace-nowrap">
          KHÁM PHÁ NGAY
        </p>
      </a>
      <div className="absolute h-[90px] left-[134px] top-[169px] w-[167px]">
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <img alt="" className="absolute h-[100.45%] left-[-16.77%] max-w-none top-[-0.23%] w-[116.77%]" src={imgTopcvLogoOnDarkBlue1} />
        </div>
      </div>
      <div className="absolute h-[433px] left-[1076px] top-[141px] w-[781px]">
        <img alt="" className="absolute inset-0 max-w-none object-cover pointer-events-none size-full" src={imgIcon1} />
      </div>
      <div className="absolute h-[334px] left-0 opacity-50 top-[260px] w-[124px]">
        <img alt="" className="absolute inset-0 max-w-none object-cover pointer-events-none size-full" src={imgTopcvBrandTheArrowWhite3} />
      </div>
      <p className="absolute font-['Alexandria',sans-serif] font-medium leading-[normal] left-[134px] text-[15px] text-white top-[255px] whitespace-nowrap">
        Tiếp lợi thế - Nối thành công
      </p>
    </div>
  );
}
